import { useCallback, useRef } from "react";

import styles from "./Switch.module.css";

import { classNames } from "../../../Utils/classNames/classNames";

export interface TabItem {
    value: string;
    content: string;
}

interface EventSwitchProps {
    value: string;
    onTabClick: (tab: TabItem) => void;
    label?: string;
    tabs: TabItem[];
}

export const Switch = (props: EventSwitchProps) => {
    const { value, label, onTabClick, tabs } = props;

    const initialValueRef = useRef<string>(value);

    const clickHandle = useCallback(
        (tab: TabItem) => () => {
            onTabClick(tab);
        },
        [onTabClick],
    );

    return (
        <div className={styles.switch}>
            {label && <div className={styles.label}>{label}</div>}
            <div className={classNames(styles.switchBlock, {}, [])}>
                <div className={styles.switchWrapper}>
                    <div
                        className={classNames(
                            styles.activeBg,
                            { [styles.active]: initialValueRef.current !== value },
                            [],
                        )}
                    />
                    {tabs.map((tab) => (
                        <button
                            className={classNames(styles.tab, { [styles.active]: tab.value === value }, [])}
                            key={tab.value}
                            onClick={clickHandle(tab)}
                        >
                            {tab.content}
                        </button>
                    ))}
                </div>
            </div>
        </div>
    );
};
